<template>
    <button 
        class="black-link" 
        type="button"
        :data-bot="dataBot"
        @click="handleClick"
    >
        {{ label }}
    </button>
</template>

<script>
export default {
    props: {
        label: {
            type: String,
            required: true
        },
        event: {
            type: String,
            required: false,
            default: null
        },
        eventParams: {
            type: Object,
            required: false,
            default: () => ({})
        },
        dataBot: {
            type: String,
            required: false,
            default: null
        }
    },
    methods: {
        handleClick() {
            if (this.event) {
                window.EventBus.emit(this.event, { params: this.eventParams });
            }
        }
    }
}
</script>

<style scoped>
button {
    border: none;
    background: none;
    padding: 0;
    display: inline;
    vertical-align: baseline;
    font: inherit;
}
</style>